// aws api profiles
import api from '../../aws/api/profiles/json.profile.api.aws';

const listCollectionsApi = (body) => api().post('/collections', body);

export default listCollectionsApi;
